// generated by genversion
const version = '6.15.7';

export { version };
//# sourceMappingURL=version.mjs.map
